import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-b65db988"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "color-primary" }
const _hoisted_2 = { class: "phone number-pad-container" }
const _hoisted_3 = ["value", "placeholder"]
const _hoisted_4 = { class: "number-pad" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("svg", {
  width: "46",
  height: "46",
  viewBox: "0 0 46 46",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}, [
  /*#__PURE__*/_createElementVNode("path", {
    d: "M20.4225 32.6412L28.0311 25.0327L35.6397 32.6412L37.6725 30.6084L30.0639 22.9998L37.6725 15.3912L35.6397 13.3584L28.0311 20.9669L20.4225 13.3584L18.3896 15.3912L25.9982 22.9998L18.3896 30.6084L20.4225 32.6412Z",
    fill: "#747474"
  }),
  /*#__PURE__*/_createElementVNode("path", {
    d: "M42.4062 5.75H17.4875C17.1947 5.75049 16.905 5.81039 16.636 5.92609C16.367 6.04179 16.1242 6.21087 15.9225 6.42311L1.4375 21.7083V24.2917L15.9225 39.5769C16.1242 39.7891 16.367 39.9582 16.636 40.0739C16.905 40.1896 17.1947 40.2495 17.4875 40.25H42.4062C42.9779 40.2493 43.526 40.0219 43.9302 39.6177C44.3344 39.2135 44.5618 38.6654 44.5625 38.0938V7.90625C44.5618 7.33458 44.3344 6.78652 43.9302 6.38229C43.526 5.97806 42.9779 5.75067 42.4062 5.75ZM41.6875 37.375H17.7966L4.3125 23.1458V22.8542L17.7966 8.625H41.6875V37.375Z",
    fill: "#747474"
  })
], -1))
const _hoisted_6 = [
  _hoisted_5
]
const _hoisted_7 = ["disabled"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Dialog = _resolveComponent("Dialog")!

  return (_openBlock(), _createBlock(_component_Dialog, {
    visible: _ctx.context.visible,
    "onUpdate:visible": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.context.visible) = $event)),
    class: "simple-dialog"
  }, {
    default: _withCtx(() => [
      _createElementVNode("h2", _hoisted_1, _toDisplayString(_ctx.context.t('unlock.adminAccess')), 1),
      _createElementVNode("div", null, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("input", {
            class: "phone",
            type: "password",
            value: _ctx.context.pin,
            placeholder: _ctx.context.t('unlock.passwordPlaceholder'),
            readonly: true,
            onFocus: _cache[0] || (_cache[0] = ($event: any) => (($event.target as any)?.blur?.()))
          }, null, 40, _hoisted_3),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("button", {
              onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.addNumber(1)))
            }, "1"),
            _createElementVNode("button", {
              onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.addNumber(2)))
            }, "2"),
            _createElementVNode("button", {
              onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.addNumber(3)))
            }, "3"),
            _createElementVNode("button", {
              onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.addNumber(4)))
            }, "4"),
            _createElementVNode("button", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.addNumber(5)))
            }, "5"),
            _createElementVNode("button", {
              onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.addNumber(6)))
            }, "6"),
            _createElementVNode("button", {
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.addNumber(7)))
            }, "7"),
            _createElementVNode("button", {
              onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.addNumber(8)))
            }, "8"),
            _createElementVNode("button", {
              onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.addNumber(9)))
            }, "9"),
            _createElementVNode("button", {
              class: "remove",
              onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.addNumber(-1)))
            }, _hoisted_6),
            _createElementVNode("button", {
              onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.addNumber(0)))
            }, "0"),
            _createElementVNode("button", {
              class: "last",
              disabled: !_ctx.context.isValid,
              onClick: _cache[12] || (_cache[12] = ($event: any) => (_ctx.savePin(_ctx.context.pin)))
            }, _toDisplayString(_ctx.context.t('common.accept')), 9, _hoisted_7)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}